/* eslint-disable no-undef */

export const SERVICEDESK_URL = plugin.servicedeskUrl;
